import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const nav = useNavigate();
  const loc = useLocation();
  const { completeGoogleAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError('Missing session_id');
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    completeGoogleAuth(sessionId)
      .then(() => {
        toast.success('Signed in with Google');
        nav('/', { replace: true });
      })
      .catch((err) => {
        const msg = err?.response?.data?.detail || err?.message || 'Sign-in failed';
        setError(msg);
        toast.error(msg);
        setTimeout(() => nav('/login', { replace: true }), 1500);
      });
  }, [completeGoogleAuth, nav, loc.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600 mx-auto" />
        <p className="mt-3 text-slate-600">{error ? error : 'Completing sign-in…'}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
